
export default function getAreaByJS(points, signed = false) {
  const normalize = point => {
    if (!Array.isArray(point)) return point;
    return { x: point[0], y: point[1] };
  };

  const l = points.length;
  let det = 0;

  let normalizedPoints = points.map(normalize);

  // Close the polygon if it's not already closed
  if (normalizedPoints[0] !== normalizedPoints[normalizedPoints.length - 1]) {
    normalizedPoints = [...normalizedPoints, normalizedPoints[0]];
  }

  for (let i = 0; i < l; i++) {
    det += normalizedPoints[i].x * normalizedPoints[i + 1].y
         - normalizedPoints[i].y * normalizedPoints[i + 1].x;
  }

  return signed ? det / 2 : Math.abs(det) / 2;
};
